import React from 'react'
import { useStore } from 'effector-react'
import { $userProfile, $userRole } from '../user'
import { path, role } from '../../libs'
import { setRedirectPath } from './model'
import { Navigate } from 'react-router-dom'
import { getRolesByGuardRules } from './constants'

type Props = {
  children?: React.ReactNode
  permission: string | string[]
  mode?: 'role' | 'permission'
}

export const Guard: React.FC<Props> = ({
  children,
  permission,
  mode = 'role',
}) => {
  const userRole = useStore($userRole)
  const userProfile = useStore($userProfile)
  const permissions = Array.isArray(permission) ? permission : [permission]

  if (userRole) {
    if (userRole.includes(role.unauthorized())) {
      setRedirectPath(location.pathname) // Сохраняем исходный путь
      return <Navigate to={path.login.entry()} />
    }

    if (userRole.includes(role.logged())) {
      const isGranted =
        mode === 'permission'
          ? permissions.some((perm) => userProfile.permissions.includes(perm))
          : permissions.some((perm) =>
              getRolesByGuardRules(perm).some((r) => userRole.includes(r)),
            )

      if (isGranted) {
        if (children) {
          return <>{children}</>
        }
      }
    }
  }

  return <></>
}
